import * as yup from "yup";
import { t } from "i18next";

export const getCaptchaSchema = (generatedCaptcha: string) => {
  return yup.object({
    captcha: yup.string().oneOf([generatedCaptcha], t("registrationPage.captcha.invalidCaptcha")),
  });
};
